import { render } from "./StoreBox.vue?vue&type=template&id=3c7cb5d6&scoped=true"
import script from "./StoreBox.vue?vue&type=script&lang=ts"
export * from "./StoreBox.vue?vue&type=script&lang=ts"

import "./StoreBox.vue?vue&type=style&index=0&id=3c7cb5d6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3c7cb5d6"

export default script